import {setConfigDynamicTable} from "@datagrupo2/dg-ng-util";
import {environment} from "../../../../environments/environment";

// export const configLocalDynamicTable: setConfigDynamicTable = {
//   apiData: {
//     path: environment.apiUrl,
//     context: '',
//     inputPipe: (a: any) => {
//       return a?.data || a;
//     },
//     outputPaginationPipe: (value: any) => {
//       const { page, size, sort } = value;
//       return {page, size, sort}
//     },
//     inputPaginationPipe: (value:any) => {
//       const { pageNumber, totalElements, totalPages } = value;
//       return { page: pageNumber, totalPages, totalElements };
//     }
//   }
// }
export const configLocalDynamicTable: setConfigDynamicTable = {
  apiData: {
    path: environment.apiUrl,
    context: '',
    inputPipe:(resp) => {
      if (Array.isArray(resp)) return resp;
      if (resp && typeof resp === 'object') {
        if ('data' in resp && Array.isArray(resp['data'])) return resp['data'];
        if ('content' in resp && Array.isArray(resp['content'])) return resp['content'];
      }
      return []
    },
    outputPaginationPipe: (resp:any) => {
      const result: any = { page: 0, totalPages: 0, totalElements: 0 };

      // If response has a nested page object (Spring Data style: { page: { number, totalPages, totalElements } })
      if (resp && resp.page && typeof resp.page === 'object') {
        if ('number' in resp.page) result.page = resp.page['number'];
        if ('totalPages' in resp.page) result.totalPages = resp.page['totalPages'];
        if ('totalElements' in resp.page) result.totalElements = resp.page['totalElements'];
        if ('size' in resp.page) (result as any).size = resp.page['size'];
        return result;
      }

      // Fallback for endpoints that return top-level pagination keys
      if (resp && typeof resp === 'object') {
        if ('page' in resp && typeof resp['page'] === 'number') result.page = resp['page'];
        if ('number' in resp) result.page = resp['number'];
        if ('pageNumber' in resp) result.page = resp['pageNumber'];
        if ('totalPages' in resp) result.totalPages = resp['totalPages'];
        if ('totalElements' in resp) result.totalElements = resp['totalElements'];
        if ('size' in resp) (result as any).size = resp['size'];
        return result;
      }

      // Array fallback (no pagination)
      if (Array.isArray(resp)) {
        (result as any).size = resp.length;
      }
      return result
    }
  },
  outputParamsPagination: (value: any) => {
    const params: any = {};
    if (value?.page !== undefined) params.page = value.page;
    if (value?.size !== undefined) params.size = value.size;
    if (value?.sort) params.sort = value.sort;
    return params;
  },

}
